export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6590.23dfd06c.jpg";